import React from "react";

import franchisedesign from "../images/FRANCHISEE_ dESIGN.jpg";
import Skill from "../images/skill.jpg";
import Experience from "../images/experience.jpg";
import Marketing from "../images/marketing.jpg";
import Earning from "../images/earning.jpg";
import logo_mrindiancoder from '../images/MR. INDIAN CODER FINAL LOGO Update 04 Sep, 2025.jpg';
import Develop from "./Develop";
import FranchiseFrom from "./FranchiseFrom";



function Distributor() {
  return (
    <>
      <div className="kalyaniwebsiteservice">
        <br />
        <div className="album py-0">
          <div className="container">
            <center>
              <img src={logo_mrindiancoder} className="mb-2" width="110" height="34" alt="logo_mrindiancoder" />
            </center>
            <center>
              <h2 style={{ color: "#553C1E" }}>MR. INDIAN CODER</h2>
               
            </center>

          </div>
        </div>
   
        <div className="album py-0">
          <div className="container">
            <div className="row">
              <div className="col-md-7 mt-3">
              <center>
                 <h5 className="mt-0 mb-2"><b>Own a Franchise – Reserve Now!</b></h5>
              </center>
                <FranchiseFrom />
              </div>
              <div className="col-md-5 mt-4">
                <img src={franchisedesign} className="d-block w-100" alt="Reactjswebsitedevelopmentwestbengal" />

              </div>
            </div>
          </div>
        </div>
        <br/>
      </div>

      <div className="website_reactjs">
        <br />
        <div className="album py-0">
          <div className="container">
            <div className="row">
              <div className="col-md-6 mt-1">
                <h2 style={{ color: "#553C1E" }} className="card-text mb-3"> <b>Website Development Franchise of MR. INDIAN CODER in your City</b></h2>
                <h5 style={{ color: "Gray" }} className="card-text mb-3 texts">Start your very own website designing company without having liability of a technical team and developing any websites. So set your
                  goal as high as you want. </h5>
                <h5 style={{ color: "Gray" }} className="card-text mb-4 texts">MR. INDIAN CODER is an awarded best web development & designing company in India, headquartered in Haydrabad. We offer high quality websites with our innovative and modern approach for our client, to ensure superb promotion on Google.
                  When you join us, You will join thousands of happy distributor from all over India</h5>
                <h5 style={{ color: "Gray" }} className="card-text mb-3 texts">The Vision of MR. INDIAN CODER is  to deliver our unique website
                  developemnt blend and value to each corner of the  world. Distributor partners of MR. INDIAN CODER are enjoying <b>huge margins </b> and impeccable growth every year. It's easy to get started with tested, tried and high_ROI driven business models. Now currently the demand
                  for creating websites in 2022 is increasing. The industry has <b>huge growth </b>potential.</h5>





            

              </div>
              <div className="col-md-6 mt-1">




                <div className="d-flex justify-content-between align-items-center">
                  <div className="card mb-4 me-3 ">
                    <img src={Skill} className="card-img-top" alt="Skill" />
                    <div class="card-body">
                      <center>
                        <h5 style={{ color: "Gray" }} className="card-title"><small>No Coding Knowledge Required</small></h5>
                      </center>
                    </div>


                  </div>
                  <div className="card mb-4 ">
                    <img src={Experience} className="card-img-top" alt="Skill" />
                    <div class="card-body">
                      <center>
                        <h5 style={{ color: "Gray" }} className="card-title"><small>No Experience Necessary Need</small></h5>
                      </center>
                    </div>


                  </div>


                </div>

                <div className="d-flex justify-content-between align-items-center">
                  <div className="card mb-4 me-3 ">
                    <img src={Marketing} className="card-img-top" alt="Marketing" />
                    <div class="card-body">
                      <center>
                        <h5 style={{ color: "Gray" }} className="card-title">Sell Website Packages to Businesses</h5>
                      </center>
                    </div>


                  </div>
                  <div className="card mb-4 me-0">
                    <img src={Earning} className="card-img-top" alt="Earning" />
                    <div class="card-body">
                      <center>
                        <h5 style={{ color: "Gray" }} className="card-title">Unlimited Earning Potential</h5>
                      </center>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


          <br />
          <div className="album py-2">

            <div className="container">

              <div className="row">
                <h5 style={{ color: "Darkblue" }} className="card-title">Know More About <b> MR. INDIAN CODER</b></h5>

              </div>


            </div>
          </div>
        </div>

        <div className="album py-0">

          <div className="container">

            <div className="row ">

              <div className="col-md-5" >
                <div className="d-flex justify-content-between align-items-center">
                  <a href="about">
                    <button className="buttonbookfranchise button2"> About Us</button>
                  </a>



                  <a href="our-development" >
                    <button className="buttonbookfranchise button2"> Our Best Work</button>
                  </a>



                </div>

              </div>


            </div>
          </div>
        </div>
        <br />
      </div>

      <div className="p-3 mb-2 bg-light text-white">
        <Develop />
        <br />
      </div>


    </>
  );
}

export default Distributor;